// import { useState, useEffect } from "react";
// import { Link } from 'react-router';
// import Cookies from 'js-cookie';
// import { getSellerComplaints } from '../../../services/customerComplaint.service';
// import {
//   AlertTriangle, Search, Clock, CheckCircle, XCircle, AlertCircle,
//   ChevronRight, Bell, FileText, TrendingDown
// } from 'lucide-react';

// const STATUS_CONFIG: Record<string, { label: string; color: string; bg: string }> = {
//   submitted: { label: 'Submitted', color: 'text-[#1E6DFF]', bg: 'bg-[#1E6DFF]/10' },
//   under_review: { label: 'Under Review', color: 'text-[#F59E0B]', bg: 'bg-[#F59E0B]/10' },
//   awaiting_response: { label: 'Awaiting Response', color: 'text-[#8B5CF6]', bg: 'bg-[#8B5CF6]/10' },
//   resolved: { label: 'Resolved', color: 'text-[#22C55E]', bg: 'bg-[#22C55E]/10' },
//   rejected: { label: 'Rejected', color: 'text-[#EF4444]', bg: 'bg-[#EF4444]/10' },
//   closed: { label: 'Closed', color: 'text-[#717182]', bg: 'bg-[#717182]/10' },
// };
// function SellerComplaintsSkeleton() {
//   return (
//     <div className="p-4 md:p-8">

//       {/* Header */}
//       <div className="flex justify-between items-center mb-6">
//         <div>
//           <Skeleton className="h-8 w-80 mb-3" />
//           <Skeleton className="h-4 w-56" />
//         </div>
//       </div>

//       {/* Alert */}
//       <div className="border border-[#E5E7EB] rounded-xl p-4 mb-6">
//         <div className="flex gap-3">
//           <Skeleton className="w-10 h-10 rounded-full" />

//           <div className="flex-1">
//             <Skeleton className="h-4 w-72 mb-2" />
//             <Skeleton className="h-3 w-56" />
//           </div>
//         </div>
//       </div>

//       {/* Stats */}
//       <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 mb-6">
//         {[1, 2, 3, 4].map((i) => (
//           <div
//             key={i}
//             className="border border-[#E5E7EB] rounded-2xl p-4"
//           >
//             <Skeleton className="h-8 w-10 mb-3" />
//             <Skeleton className="h-4 w-28" />
//           </div>
//         ))}
//       </div>

//       {/* Table */}
//       <div className="bg-white rounded-2xl border border-[#E5E7EB] overflow-hidden">

//         {/* Tabs + Search */}
//         <div className="flex justify-between items-center p-4 border-b border-[#E5E7EB]">

//           <div className="flex gap-2">
//             {[1, 2, 3, 4].map((i) => (
//               <Skeleton
//                 key={i}
//                 className="h-10 w-20 rounded-xl"
//               />
//             ))}
//           </div>

//           <Skeleton className="h-10 w-52 rounded-xl" />
//         </div>

//         {/* Table Header */}
//         <div className="hidden md:grid grid-cols-[auto_1fr_auto_auto_auto_auto] gap-4 px-5 py-3 border-b border-[#E5E7EB] bg-[#F5F7FA]">
//           <Skeleton className="h-4 w-14" />
//           <Skeleton className="h-4 w-32" />
//           <Skeleton className="h-4 w-24" />
//           <Skeleton className="h-4 w-20" />
//           <Skeleton className="h-4 w-16" />
//           <Skeleton className="h-4 w-12" />
//         </div>

//         {/* Rows */}
//         <div className="divide-y divide-[#E5E7EB]">
//           {[1, 2, 3, 4, 5].map((row) => (
//             <div
//               key={row}
//               className="grid grid-cols-[auto_1fr_auto_auto_auto_auto] gap-4 items-center px-5 py-4"
//             >
//               <div>
//                 <Skeleton className="h-4 w-20 mb-2" />
//                 <Skeleton className="h-3 w-14" />
//               </div>

//               <div>
//                 <Skeleton className="h-4 w-52 mb-2" />
//                 <Skeleton className="h-3 w-28" />
//               </div>

//               <Skeleton className="h-7 w-36 rounded-lg" />

//               <Skeleton className="h-4 w-20" />

//               <Skeleton className="h-7 w-28 rounded-full" />

//               <Skeleton className="h-4 w-12" />
//             </div>
//           ))}
//         </div>

//       </div>
//     </div>
//   );
// }

// const COMPLAINTS = [
//   { id: 'CMP-482910', vehicle: 'Mercedes C-Class 2022', buyer: 'Karim A.', category: 'Fraudulent Listing', status: 'awaiting_response', lastUpdated: 'Jun 4, 2026', urgent: true },
//   { id: 'CMP-391847', vehicle: 'BMW 3 Series 2021', buyer: 'Sara B.', category: 'Vehicle Not As Described', status: 'under_review', lastUpdated: 'May 29, 2026', urgent: false },
//   { id: 'CMP-284710', vehicle: 'Audi A4 2020', buyer: 'Mohammed Z.', category: 'Incorrect Vehicle Info', status: 'resolved', lastUpdated: 'May 18, 2026', urgent: false },
//   { id: 'CMP-173920', vehicle: 'Toyota Corolla 2019', buyer: 'Fatima L.', category: 'Payment Issues', status: 'closed', lastUpdated: 'Apr 25, 2026', urgent: false },
// ];

// const Skeleton = ({ className = "" }: { className?: string }) => (
//   <div className={`animate-pulse bg-gray-200 rounded-lg ${className}`} />
// );

// const TABS = [
//   { key: 'all', label: 'All' },
//   { key: 'open', label: 'Open', statuses: ['submitted', 'under_review', 'awaiting_response'] },
//   { key: 'resolved', label: 'Resolved', statuses: ['resolved'] },
//   { key: 'closed', label: 'Closed', statuses: ['closed', 'rejected'] },
// ];
// // const formatDate = (value: string) => new Intl.DateTimeFormat('en-US', { month: 'short', day: 'numeric', year: 'numeric' }).format(new Date(value));
// const formatDate = (value?: string | null) => {
//   if (!value) return '-';

//   const date = new Date(value);

//   if (Number.isNaN(date.getTime())) {
//     return '-';
//   }

//   return new Intl.DateTimeFormat('en-US', {
//     month: 'short',
//     day: 'numeric',
//     year: 'numeric',
//   }).format(date);
// };
// export function SellerComplaints() {
//   const [tab, setTab] = useState('all');
//   const [search, setSearch] = useState('');
//   const [loading, setLoading] = useState(true);
//   const [complaints, setComplaints] = useState<any[]>([]);
//   const [stats, setStats] = useState({ total: 0, open: 0, resolved: 0, awaitingResponse: 0, urgent: 0 });
//   const [error, setError] = useState('');
//   const complaintBasePath = Number(Cookies.get('customerType')) === 3 ? '/dealer/complaints' : '/dashboard/complaints';

//   useEffect(() => {
//     getSellerComplaints().then(result => { setComplaints(result.data || []); setStats(result.stats || {}); })
//       .catch((requestError: any) => setError(requestError.response?.data?.message || 'Unable to load complaints'))
//       .finally(() => setLoading(false));
//   }, []);

//   const filtered = complaints.filter(c => {
//     const tabDef = TABS.find(t => t.key === tab);
//     const matchTab = tab === 'all' || (tabDef?.statuses?.includes(c.Status) ?? true);
//     const matchSearch = !search || String(c.vehicle?.title || '').toLowerCase().includes(search.toLowerCase()) ||
//       String(c.buyer?.name || '').toLowerCase().includes(search.toLowerCase()) || String(c.ComplaintNumber || c.id).toLowerCase().includes(search.toLowerCase());
//     return matchTab && matchSearch;
//   });

//   const openCount = stats.open || 0;
//   const urgentCount = stats.urgent || 0;
//   if (loading) {
//   return <SellerComplaintsSkeleton />;
// }
//   if (error) return <div className="p-4 md:p-8"><div className="rounded-2xl border border-[#EF4444]/30 bg-[#EF4444]/5 p-6 text-center text-sm text-[#EF4444]">{error}</div></div>;

//   return (
//     <div className="p-4 md:p-8">
//       {/* Header */}
//       <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 mb-6">
//         <div>
//           <h1 className="text-2xl text-[#2D323A]">Complaints Against My Listings</h1>
//           <p className="text-[#717182] text-sm">Manage buyer complaints and disputes</p>
//         </div>
//       </div>

//       {/* Alert for urgent */}
//       {urgentCount > 0 && (
//         <div className="flex items-start gap-3 bg-[#EF4444]/10 border border-[#EF4444]/20 rounded-xl px-4 py-3.5 mb-6">
//           <Bell className="w-5 h-5 text-[#EF4444] flex-shrink-0 mt-0.5" />
//           <div>
//             <p className="text-sm text-[#EF4444]">{urgentCount} complaint{urgentCount > 1 ? 's' : ''} require{urgentCount === 1 ? 's' : ''} your response</p>
//             <p className="text-xs text-[#EF4444]/70 mt-0.5">Respond within 72 hours to avoid account restrictions.</p>
//           </div>
//         </div>
//       )}

//       {/* Stats */}
//       <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 mb-6">
//         {[
//           { label: 'Total', value: stats.total || 0, color: 'text-[#2D323A]', bg: 'bg-[#F5F7FA]' },
//           { label: 'Open', value: openCount, color: 'text-[#F59E0B]', bg: 'bg-[#F59E0B]/10' },
//           { label: 'Resolved', value: stats.resolved || 0, color: 'text-[#22C55E]', bg: 'bg-[#22C55E]/10' },
//           { label: 'Awaiting Your Reply', value: stats.awaitingResponse || 0, color: 'text-[#8B5CF6]', bg: 'bg-[#8B5CF6]/10' },
//         ].map(s => (
//           <div key={s.label} className={`${s.bg} rounded-2xl p-4 border border-[#E5E7EB]`}>
//             <p className={`text-2xl ${s.color}`}>{s.value}</p>
//             <p className="text-sm text-[#717182]">{s.label}</p>
//           </div>
//         ))}
//       </div>

//       {/* Table */}
//       <div className="bg-white rounded-2xl border border-[#E5E7EB] overflow-hidden">
//         <div className="flex flex-col sm:flex-row sm:items-center gap-3 p-4 border-b border-[#E5E7EB]">
//           <div className="flex gap-1">
//             {TABS.map(t => (
//               <button
//                 key={t.key}
//                 onClick={() => setTab(t.key)}
//                 className={`px-4 py-2 rounded-xl text-sm transition-colors ${tab === t.key ? 'bg-[#1E6DFF] text-white' : 'text-[#717182] hover:bg-[#F5F7FA]'}`}
//               >
//                 {t.label}
//               </button>
//             ))}
//           </div>
//           <div className="sm:ml-auto relative">
//             <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-[#717182]" />
//             <input
//               type="text"
//               value={search}
//               onChange={e => setSearch(e.target.value)}
//               placeholder="Search..."
//               className="pl-9 pr-4 py-2 bg-[#F5F7FA] border border-[#E5E7EB] rounded-xl text-sm focus:outline-none focus:border-[#1E6DFF] w-48"
//             />
//           </div>
//         </div>

//         {/* Desktop */}
//         <div className="hidden md:block">
//           <div className="grid grid-cols-[auto_1fr_auto_auto_auto_auto_auto] gap-4 px-5 py-3 bg-[#F5F7FA] border-b border-[#E5E7EB] text-xs text-[#717182]">
//             <span>ID</span><span>Vehicle / Buyer</span><span>Category</span><span>Last Updated</span><span>Status</span><span></span>
//           </div>
//           {filtered.length === 0 ? <EmptyState /> : (
//             <div className="divide-y divide-[#E5E7EB]">
//               {filtered.map(c => {
//                 const s = STATUS_CONFIG[c.Status] || STATUS_CONFIG.submitted;
//                 return (
//                   <div key={c.id} className={`grid grid-cols-[auto_1fr_auto_auto_auto_auto] gap-4 items-center px-5 py-4 hover:bg-[#F5F7FA] transition-colors ${c.IsUrgent ? 'border-l-2 border-[#EF4444]' : ''}`}>
//                     <div className="w-24">
//                       <span className="text-xs text-[#717182]">#{c.ComplaintNumber || c.id}</span>
//                       {c.IsUrgent && <span className="block text-xs text-[#EF4444]">Urgent</span>}
//                     </div>
//                     <div>
//                       <p className="text-sm text-[#2D323A]">{c.vehicle?.title || 'Vehicle listing'}</p>
//                       <p className="text-xs text-[#717182]">Buyer: {c.buyer?.name || 'Buyer'}</p>
//                     </div>
//                     <span className="text-xs px-2 py-1 bg-[#F5F7FA] text-[#717182] rounded-lg border border-[#E5E7EB] whitespace-nowrap">{c.Category}</span>
//                     <span className="text-xs text-[#717182] whitespace-nowrap">{formatDate(c.LastModifiedOn || c.CreatedOn)}</span>
//                     <span className={`text-xs px-2.5 py-1 rounded-full whitespace-nowrap ${s.bg} ${s.color}`}>{s.label}</span>
//                     <Link to={`${complaintBasePath}/${c.id}`} className="flex items-center gap-1 text-xs text-[#1E6DFF] hover:underline whitespace-nowrap">
//                       View <ChevronRight className="w-3 h-3" />
//                     </Link>
//                   </div>
//                 );
//               })}
//             </div>
//           )}
//         </div>

//         {/* Mobile */}
//         <div className="md:hidden divide-y divide-[#E5E7EB]">
//           {filtered.length === 0 ? <EmptyState /> : filtered.map(c => {
//             const s = STATUS_CONFIG[c.Status] || STATUS_CONFIG.submitted;
//             return (
//               <Link key={c.id} to={`${complaintBasePath}/${c.id}`} className={`block p-4 hover:bg-[#F5F7FA] transition-colors ${c.IsUrgent ? 'border-l-2 border-[#EF4444]' : ''}`}>
//                 <div className="flex items-start justify-between mb-2">
//                   <div>
//                     <p className="text-sm text-[#2D323A]">{c.vehicle?.title || 'Vehicle listing'}</p>
//                     <p className="text-xs text-[#717182]">#{c.ComplaintNumber || c.id} · {c.buyer?.name || 'Buyer'}</p>
//                   </div>
//                   <span className={`text-xs px-2 py-0.5 rounded-full ${s.bg} ${s.color}`}>{s.label}</span>
//                 </div>
//                 <div className="flex flex-wrap gap-2">
//                   <span className="text-xs px-2 py-0.5 bg-[#F5F7FA] text-[#717182] rounded-lg border border-[#E5E7EB]">{c.Category}</span>
//                   <span className="text-xs text-[#717182]">{formatDate(c.LastModifiedOn || c.CreatedOn)}</span>
//                   {c.IsUrgent && <span className="text-xs text-[#EF4444]">⚠ Response needed</span>}
//                 </div>
//               </Link>
//             );
//           })}
//         </div>
//       </div>
//     </div>
//   );
// }

// function EmptyState() {
//   return (
//     <div className="flex flex-col items-center justify-center py-16 text-center">
//       <div className="w-14 h-14 bg-[#22C55E]/10 rounded-full flex items-center justify-center mb-4">
//         <CheckCircle className="w-7 h-7 text-[#22C55E]" />
//       </div>
//       <p className="text-[#2D323A] mb-1">No complaints found</p>
//       <p className="text-sm text-[#717182]">Great! No complaints matching this filter.</p>
//     </div>
//   );
// }
// src/components/sellerComplaint/SellerComplaints.tsx
import { useState, useEffect } from "react";
import { Link } from 'react-router';
import { useTranslation } from 'react-i18next';
import Cookies from 'js-cookie';
import { getSellerComplaints } from '../../../services/customerComplaint.service';
import {
  AlertTriangle, Search, Clock, CheckCircle, XCircle, AlertCircle,
  ChevronRight, Bell, FileText, TrendingDown
} from 'lucide-react';

// ----- Helper to get translated status config -----
const getStatusConfig = (t: any) => ({
  submitted: { label: t('sellerComplaints.status.submitted'), color: 'text-[#1E6DFF]', bg: 'bg-[#1E6DFF]/10' },
  under_review: { label: t('sellerComplaints.status.under_review'), color: 'text-[#F59E0B]', bg: 'bg-[#F59E0B]/10' },
  awaiting_response: { label: t('sellerComplaints.status.awaiting_response'), color: 'text-[#8B5CF6]', bg: 'bg-[#8B5CF6]/10' },
  resolved: { label: t('sellerComplaints.status.resolved'), color: 'text-[#22C55E]', bg: 'bg-[#22C55E]/10' },
  rejected: { label: t('sellerComplaints.status.rejected'), color: 'text-[#EF4444]', bg: 'bg-[#EF4444]/10' },
  closed: { label: t('sellerComplaints.status.closed'), color: 'text-[#717182]', bg: 'bg-[#717182]/10' },
});

function SellerComplaintsSkeleton() {
  return (
    <div className="p-4 md:p-8">

      {/* Header */}
      <div className="flex justify-between items-center mb-6">
        <div>
          <Skeleton className="h-8 w-80 mb-3" />
          <Skeleton className="h-4 w-56" />
        </div>
      </div>

      {/* Alert */}
      <div className="border border-[#E5E7EB] rounded-xl p-4 mb-6">
        <div className="flex gap-3">
          <Skeleton className="w-10 h-10 rounded-full" />

          <div className="flex-1">
            <Skeleton className="h-4 w-72 mb-2" />
            <Skeleton className="h-3 w-56" />
          </div>
        </div>
      </div>

      {/* Stats */}
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 mb-6">
        {[1, 2, 3, 4].map((i) => (
          <div
            key={i}
            className="border border-[#E5E7EB] rounded-2xl p-4"
          >
            <Skeleton className="h-8 w-10 mb-3" />
            <Skeleton className="h-4 w-28" />
          </div>
        ))}
      </div>

      {/* Table */}
      <div className="bg-white rounded-2xl border border-[#E5E7EB] overflow-hidden">

        {/* Tabs + Search */}
        <div className="flex justify-between items-center p-4 border-b border-[#E5E7EB]">

          <div className="flex gap-2">
            {[1, 2, 3, 4].map((i) => (
              <Skeleton
                key={i}
                className="h-10 w-20 rounded-xl"
              />
            ))}
          </div>

          <Skeleton className="h-10 w-52 rounded-xl" />
        </div>

        {/* Table Header */}
        <div className="hidden md:grid grid-cols-[auto_1fr_auto_auto_auto_auto] gap-4 px-5 py-3 border-b border-[#E5E7EB] bg-[#F5F7FA]">
          <Skeleton className="h-4 w-14" />
          <Skeleton className="h-4 w-32" />
          <Skeleton className="h-4 w-24" />
          <Skeleton className="h-4 w-20" />
          <Skeleton className="h-4 w-16" />
          <Skeleton className="h-4 w-12" />
        </div>

        {/* Rows */}
        <div className="divide-y divide-[#E5E7EB]">
          {[1, 2, 3, 4, 5].map((row) => (
            <div
              key={row}
              className="grid grid-cols-[auto_1fr_auto_auto_auto_auto] gap-4 items-center px-5 py-4"
            >
              <div>
                <Skeleton className="h-4 w-20 mb-2" />
                <Skeleton className="h-3 w-14" />
              </div>

              <div>
                <Skeleton className="h-4 w-52 mb-2" />
                <Skeleton className="h-3 w-28" />
              </div>

              <Skeleton className="h-7 w-36 rounded-lg" />

              <Skeleton className="h-4 w-20" />

              <Skeleton className="h-7 w-28 rounded-full" />

              <Skeleton className="h-4 w-12" />
            </div>
          ))}
        </div>

      </div>
    </div>
  );
}

// ----- Helper components -----
const Skeleton = ({ className = "" }: { className?: string }) => (
  <div className={`animate-pulse bg-gray-200 rounded-lg ${className}`} />
);

const formatDate = (value?: string | null) => {
  if (!value) return '-';
  const date = new Date(value);
  if (isNaN(date.getTime())) return '-';
  return new Intl.DateTimeFormat('en-US', { month: 'short', day: 'numeric', year: 'numeric' }).format(date);
};

const formatCategory = (cat?: string | null) => {
  if (!cat) return '-';
  if (cat.startsWith('categories.')) {
    return cat.replace('categories.', '').replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase());
  }
  return cat;
};

function EmptyState({ t }: { t: any }) {
  return (
    <div className="flex flex-col items-center justify-center py-16 text-center">
      <div className="w-14 h-14 bg-[#22C55E]/10 rounded-full flex items-center justify-center mb-4">
        <CheckCircle className="w-7 h-7 text-[#22C55E]" />
      </div>
      <p className="text-[#2D323A] mb-1">{t('sellerComplaints.empty.title')}</p>
      <p className="text-sm text-[#717182]">{t('sellerComplaints.empty.description')}</p>
    </div>
  );
}

export function SellerComplaints() {
  const { t } = useTranslation('auth');
  const statusConfig = getStatusConfig(t);
  const [tab, setTab] = useState('all');
  const [search, setSearch] = useState('');
  const [loading, setLoading] = useState(true);
  const [complaints, setComplaints] = useState<any[]>([]);
  const [stats, setStats] = useState({ total: 0, open: 0, resolved: 0, awaitingResponse: 0, urgent: 0 });
  const [page, setPage] = useState(1);
  const [pagination, setPagination] = useState({ total_records: 0, total_pages: 0, page_number: 1, page_size: 10 });
  const [error, setError] = useState('');
  const complaintBasePath = Number(Cookies.get('customerType')) === 3 ? '/dealer/complaints' : '/dashboard/complaints';

  // Tabs with translations
  const tabs = [
    { key: 'all', label: t('sellerComplaints.tabs.all') },
    { key: 'open', label: t('sellerComplaints.tabs.open'), statuses: ['submitted', 'under_review', 'awaiting_response'] },
    { key: 'resolved', label: t('sellerComplaints.tabs.resolved'), statuses: ['resolved'] },
    { key: 'closed', label: t('sellerComplaints.tabs.closed'), statuses: ['closed', 'rejected'] },
  ];

  useEffect(() => {
    getSellerComplaints()
      .then(result => {
        setComplaints(result.data || []);
        setStats(result.stats || {});
      })
      .catch((requestError: any) => setError(requestError.response?.data?.message || t('sellerComplaints.error')))
      .finally(() => setLoading(false));
  }, [page]);

  const filtered = complaints.filter(c => {
    const tabDef = tabs.find(t => t.key === tab);
    const matchTab = tab === 'all' || (tabDef?.statuses?.includes(c.Status) ?? true);
    const matchSearch = !search ||
      String(c.vehicle?.title || '').toLowerCase().includes(search.toLowerCase()) ||
      String(c.buyer?.name || '').toLowerCase().includes(search.toLowerCase()) ||
      String(c.ComplaintNumber || c.id).toLowerCase().includes(search.toLowerCase());
    return matchTab && matchSearch;
  });

  const openCount = stats.open || 0;
  const urgentCount = stats.urgent || 0;

  if (loading) {
    return <SellerComplaintsSkeleton />;
  }

  if (error) {
    return (
      <div className="p-4 md:p-8">
        <div className="rounded-2xl border border-[#EF4444]/30 bg-[#EF4444]/5 p-6 text-center text-sm text-[#EF4444]">
          {error}
        </div>
      </div>
    );
  }

  return (
    <div className="p-4 md:p-8">
      {/* Header */}
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 mb-6">
        <div>
          <h1 className="text-2xl text-[#2D323A]">{t('sellerComplaints.title')}</h1>
          <p className="text-[#717182] text-sm">{t('sellerComplaints.subtitle')}</p>
        </div>
      </div>

      {/* Alert for urgent complaints */}
      {urgentCount > 0 && (
        <div className="flex items-start gap-3 bg-[#EF4444]/10 border border-[#EF4444]/20 rounded-xl px-4 py-3.5 mb-6">
          <Bell className="w-5 h-5 text-[#EF4444] flex-shrink-0 mt-0.5" />
          <div>
            <p className="text-sm text-[#EF4444]">
              {urgentCount === 1
                ? t('sellerComplaints.alert.urgent', { count: urgentCount })
                : t('sellerComplaints.alert.urgent_plural', { count: urgentCount })}
            </p>
            <p className="text-xs text-[#EF4444]/70 mt-0.5">{t('sellerComplaints.alert.deadline')}</p>
          </div>
        </div>
      )}

      {/* Stats */}
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 mb-6">
        {[
          { label: t('sellerComplaints.stats.total'), value: stats.total || 0, color: 'text-[#2D323A]', bg: 'bg-[#F5F7FA]' },
          { label: t('sellerComplaints.stats.open'), value: openCount, color: 'text-[#F59E0B]', bg: 'bg-[#F59E0B]/10' },
          { label: t('sellerComplaints.stats.resolved'), value: stats.resolved || 0, color: 'text-[#22C55E]', bg: 'bg-[#22C55E]/10' },
          { label: t('sellerComplaints.stats.awaitingReply'), value: stats.awaitingResponse || 0, color: 'text-[#8B5CF6]', bg: 'bg-[#8B5CF6]/10' },
        ].map(s => (
          <div key={s.label} className={`${s.bg} rounded-2xl p-4 border border-[#E5E7EB]`}>
            <p className={`text-2xl ${s.color}`}>{s.value}</p>
            <p className="text-sm text-[#717182]">{s.label}</p>
          </div>
        ))}
      </div>

      {/* Table */}
      <div className="bg-white rounded-2xl border border-[#E5E7EB] overflow-hidden">
        <div className="flex flex-col sm:flex-row sm:items-center gap-3 p-4 border-b border-[#E5E7EB]">
          <div className="flex gap-1">
            {tabs.map(t => (
              <button
                key={t.key}
                onClick={() => setTab(t.key)}
                className={`px-4 py-2 rounded-xl text-sm transition-colors ${tab === t.key ? 'bg-[#1E6DFF] text-white' : 'text-[#717182] hover:bg-[#F5F7FA]'}`}
              >
                {t.label}
              </button>
            ))}
          </div>
          <div className="sm:ml-auto relative">
            <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-[#717182]" />
            <input
              type="text"
              value={search}
              onChange={e => setSearch(e.target.value)}
              placeholder={t('sellerComplaints.search.placeholder')}
              className="pl-9 pr-4 py-2 bg-[#F5F7FA] border border-[#E5E7EB] rounded-xl text-sm focus:outline-none focus:border-[#1E6DFF] w-48"
            />
          </div>
        </div>

        {/* Desktop */}
        <div className="hidden md:block">
          <div className="grid grid-cols-[auto_1fr_auto_auto_auto_auto] gap-4 px-5 py-3 bg-[#F5F7FA] border-b border-[#E5E7EB] text-xs text-[#717182]">
            <span className="w-28">{t('sellerComplaints.table.id')}</span>
            <span>{t('sellerComplaints.table.vehicle')}</span>
            <span>{t('sellerComplaints.table.category')}</span>
            <span>{t('sellerComplaints.table.lastUpdated')}</span>
            <span>{t('sellerComplaints.table.status')}</span>
            <span></span>
          </div>
          {filtered.length === 0 ? <EmptyState t={t} /> : (
            <div className="divide-y divide-[#E5E7EB]">
              {filtered.map(c => {
                const s = statusConfig[c.Status as keyof typeof statusConfig] || statusConfig.submitted;
                return (
                  <div key={c.id} className={`grid grid-cols-[auto_1fr_auto_auto_auto_auto] gap-4 items-center px-5 py-4 hover:bg-[#F5F7FA] transition-colors ${c.IsUrgent ? 'border-l-2 border-[#EF4444]' : ''}`}>
                    <div className="w-28">
                      <span className="text-xs text-[#717182] font-mono whitespace-nowrap">
                        #{c.ReferenceNumber || c.referenceNumber || (c.id ? c.id.slice(0, 8) : '')}
                      </span>
                      {c.IsUrgent && <span className="block text-xs text-[#EF4444]">{t('sellerComplaints.badges.urgent')}</span>}
                    </div>
                    <div>
                      <p className="text-sm text-[#2D323A]">{c.vehicle?.title || 'Vehicle listing'}</p>
                      <p className="text-xs text-[#717182]">{t('sellerComplaints.buyer_prefix')}{c.buyer?.name || 'Buyer'}</p>
                    </div>
                    <span className="text-xs px-2 py-1 bg-[#F5F7FA] text-[#717182] rounded-lg border border-[#E5E7EB] whitespace-nowrap">{formatCategory(c.Category)}</span>
                    <span className="text-xs text-[#717182] whitespace-nowrap">{formatDate(c.LastModifiedOn || c.CreatedOn)}</span>
                    <span className={`text-xs px-2.5 py-1 rounded-full whitespace-nowrap ${s.bg} ${s.color}`}>{s.label}</span>
                    <Link to={`${complaintBasePath}/${c.id}`} className="flex items-center gap-1 text-xs text-[#1E6DFF] hover:underline whitespace-nowrap">
                      {t('sellerComplaints.table.view')} <ChevronRight className="w-3 h-3" />
                    </Link>
                  </div>
                );
              })}
            </div>
          )}
        </div>

        {/* Mobile */}
        <div className="md:hidden divide-y divide-[#E5E7EB]">
          {filtered.length === 0 ? <EmptyState t={t} /> : filtered.map(c => {
            const s = statusConfig[c.Status as keyof typeof statusConfig] || statusConfig.submitted;
            return (
              <Link key={c.id} to={`${complaintBasePath}/${c.id}`} className={`block p-4 hover:bg-[#F5F7FA] transition-colors ${c.IsUrgent ? 'border-l-2 border-[#EF4444]' : ''}`}>
                <div className="flex items-start justify-between mb-2">
                  <div>
                    <p className="text-sm text-[#2D323A]">{c.vehicle?.title || 'Vehicle listing'}</p>
                    <p className="text-xs text-[#717182]">#{c.ReferenceNumber || c.referenceNumber || (c.id ? c.id.slice(0, 8) : '')} · {c.buyer?.name || 'Buyer'}</p>
                  </div>
                  <span className={`text-xs px-2 py-0.5 rounded-full ${s.bg} ${s.color}`}>{s.label}</span>
                </div>
                <div className="flex flex-wrap gap-2">
                  <span className="text-xs px-2 py-0.5 bg-[#F5F7FA] text-[#717182] rounded-lg border border-[#E5E7EB]">{formatCategory(c.Category)}</span>
                  <span className="text-xs text-[#717182]">{formatDate(c.LastModifiedOn || c.CreatedOn)}</span>
                  {c.IsUrgent && <span className="text-xs text-[#EF4444]">{t('sellerComplaints.badges.response_needed')}</span>}
                </div>
              </Link>
            );
          })}
        </div>

        {pagination.total_records > 0 && (
          <div className="flex items-center justify-between gap-3 p-4 border-t border-[#E5E7EB] text-sm">
            <span className="text-[#717182]">
              Showing {((pagination.page_number - 1) * pagination.page_size) + 1}–{Math.min(pagination.page_number * pagination.page_size, pagination.total_records)} of {pagination.total_records} complaints
            </span>
            <div className="flex gap-2">
              <button onClick={() => setPage(current => Math.max(1, current - 1))} disabled={pagination.page_number <= 1} className="px-3 py-2 border border-[#E5E7EB] rounded-lg text-[#2D323A] disabled:opacity-50 disabled:cursor-not-allowed hover:border-[#1E6DFF]">Previous</button>
              <button onClick={() => setPage(current => Math.min(pagination.total_pages, current + 1))} disabled={pagination.page_number >= pagination.total_pages} className="px-3 py-2 border border-[#E5E7EB] rounded-lg text-[#2D323A] disabled:opacity-50 disabled:cursor-not-allowed hover:border-[#1E6DFF]">Next</button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}